module.exports = __webpack_public_path__ + "media/images/logo-white-d9e2bea6bdd9d9c78ce3cab0a5c81072.png";